import Vue from "vue";
import router from "./router";
import App from "./App.vue";

// swiper=========
// import Swiper from "swiper";
// import "swiper/css/swiper.css";
// Vue.prototype.Swiper = Swiper

// swiper工具================================
// import swiper from '@/utils/swiper'
// Vue.prototype.$swiper = swiper

// vant============
// import { Toast } from "vant";
// import "vant/lib/index.css";
// Vue.use(Toast);

// 公共样式
import "@/assets/css/flex.css";
import "@/assets/css/reset.css";

// 公共数据
import * as publicData from "@/utils/publicData";
Vue.prototype.$publicData = publicData.publicData;

// theone============================
import * as theoneCommon from "@/plugin/theone/theoneCommon";
import * as theoneActivity from "@/plugin/theone/theoneActivity";
Vue.prototype.$TheoneCommon = theoneCommon.theoneCommon;
Vue.prototype.$TheoneActivity = theoneActivity.theoneActivity;

// 工具==============================
import util from "@/utils/util";
Vue.prototype.$util = util;

// 安卓方法==============================================
import * as androidNative from "@/utils/androidNative";
Vue.prototype.$AndroidNative = androidNative.AndroidNative;

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
